import { Pipe, PipeTransform } from '@angular/core';

interface Value { key: string, value: any };

@Pipe({
  name: 'keysort',
})
export class KeysortPipe implements PipeTransform {
  transform(value: Value[], sortFn: (k) => string, sortingArr: string[] = []): Value[] {
    if (!value || !value.length) {
      return value;
    }

    return value.sort((a, b) => {
      return sortingArr.indexOf(sortFn(a.key)) > sortingArr.indexOf(sortFn(b.key)) ? 1 : -1;
    })
  }
}
